import { ChevronDownIcon } from '@commenda/icons';
import { cn } from '@commenda/utils';

interface SectionTitleProps {
  title: string;
  isExpanded: boolean;
  onToggle: () => void;
  className?: string;
}

export const SectionTitle = ({
  title,
  isExpanded,
  onToggle,
  className,
}: SectionTitleProps) => (
  <button
    type="button"
    onClick={onToggle}
    aria-expanded={isExpanded}
    className={cn(
      'group flex w-fit items-center gap-sm rounded-sm outline-none focus-visible:ring-2 focus-visible:ring-fg-tertiary',
      className
    )}
  >
    <span className="txt-extra-small-medium text-text-secondary transition-colors duration-150 group-hover:text-text-primary">
      {title}
    </span>
    <ChevronDownIcon
      width={14}
      height={14}
      className={cn(
        'text-fg-quaternary transition-[transform,color] duration-200 ease-out group-hover:text-text-primary',
        !isExpanded && '-rotate-90'
      )}
    />
  </button>
);
